import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { OverlayTrigger, Popover, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';
import { toastr } from 'react-redux-toastr';
import { show } from 'redux-modal';
import Confirm from 'react-confirm-bootstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setLoader, removeLoader, toggleRemovedAds } from '../../../actions';
import { AdvertiserApi } from '../../../api';
import { Spinner } from '../../common';
import { convertMillsToDollars } from '../../../utils/helpers/currency';
import { AdsForm } from './';

const statusType = {
  removed: -1,
  paused: 0,
  active: 1
};

class AdsIndexTable extends Component {
  componentDidMount() {
    this.fetchResource();
  }
  
  onDateChange(prevProps) {
    const { startDate, endDate } = this.props;

    if ((prevProps.startDate !== startDate) || (prevProps.endDate !== endDate)) {
      this.fetchAds({
        since: startDate.format('ddd, DD MMM YYYY'),
        until: endDate.format('ddd, DD MMM YYYY')
      });
    }
  }

  fetchResource(params = {}) {
    const { account, dispatch, adReports } = this.props;
    if (account.uuid) {
      const data = {
        ...params,
        account_id: account.uuid
      };

      dispatch(AdvertiserApi.actions.ads.get(data, (_error, success) => {
        if (success) {
          if (success.data.length > 0) {
            const adReportData = {
              account_id: account.uuid,
              referencenumbers: success.data.map(ad => ad.referencenumber),
              since: params.since || moment().startOf('month').format('ddd, DD MMM YYYY'),
              until: params.until || moment().endOf('month').format('ddd, DD MMM YYYY')
            };
            dispatch(AdvertiserApi.actions.adReports.get(adReportData));
          } else {
            dispatch({
              type: AdvertiserApi.events.adReports.actionSuccess,
              syncing: false,
              data: { ...adReports, data: [] }
            });
          }
        }
      }));
    }
  }

  handleAdStatus(r, action) {
    const { dispatch, account, ads } = this.props;
    const args = [r.id, {
      account_id: account.uuid,
      referencenumber: r.referencenumber,
      campaign_id: r.campaign_id,
      status: action === 'Pause' ? 'paused' : 'active'
    }];

    dispatch(setLoader('AdStatusUpdate'));
    dispatch(AdvertiserApi.actions.adUpdate.patch(...args, (_error, success) => {
      document.body.click();
      dispatch(removeLoader('AdStatusUpdate'));
      if (success) {
        const collection = [...ads.data].map((obj) => {
          return obj.uuid === success.data.uuid ? success.data : obj;
        });

        dispatch({
          type: AdvertiserApi.events.ads.actionSuccess,
          syncing: false,
          data: { ...ads, data: collection, meta: { ...ads.meta } }
        });
        toastr.success(`${success.data.title} Ad successfully ${action === 'Pause' ? 'paused' : 'resumed'}`);
      }
    }));
  }

  handleRemoveAd(ad) {
    const { dispatch, account, ads } = this.props;
    const args = [ad.id, {
      account_id: account.uuid,
      referencenumber: ad.referencenumber,
      campaign_id: ad.campaign_id
    }];

    dispatch(setLoader('AdStatusUpdate'));
    dispatch(AdvertiserApi.actions.adDelete.delete(...args, (_error, success) => {
      document.body.click();
      dispatch(removeLoader('AdStatusUpdate'));
      if (success) {
        const adsCollection = [...ads.data].map((obj) => {
          return obj.referencenumber === success.referencenumber ? { ...obj, status: 'removed' } : { ...obj };
        });

        dispatch({
          type: AdvertiserApi.events.ads.actionSuccess,
          syncing: false,
          data: { ...ads, data: adsCollection, meta: { ...ads.meta } }
        });
        toastr.success('Ad successfully removed.');
      } else {
        toastr.error('An error has occured while trying to remove the ad.  Please try again later.');
      }
    }));
  }

  handleAdEdit(title, ad) {
    const { dispatch, account } = this.props;

    dispatch(show('AdFormModal', {
      account,
      heading: `Editing Ad - ${title}`,
      formAction: 'Update',
      selfServeCampaignId: ad.campaign_id,
      initialValues: {
        ...ad,
        bid: convertMillsToDollars(ad.bid),
      }
    }));
  }

  handleShowRemovedAds() {
    const { dispatch } = this.props;
    dispatch(toggleRemovedAds());
  }

  handleStatusPopover(c, r) {
    const action = (['active', 'pending'].includes(r.status)) ? 'Pause' : 'Resume';
    return (r.status === 'removed' || r.campaign_status === 'removed' || r.campaign_effective_status === 'campaign_ended') ? (
      <div className={`campaign circle ${r.status}`} />
    ) : (
        <OverlayTrigger
          arrowProps
          trigger="click"
          placement="right"
          delay={100}
          rootClose
          overlay={
            <Popover
              id={`${c}-ad-popover`}
            >
              <Button
                style={{ width: '100%' }}
                onClick={this.handleAdStatus.bind(this, r, action)}
              >
                {action} Ad
            </Button>
              <br />
              <Confirm
                onConfirm={this.handleRemoveAd.bind(this, r)}
                body={
                  <div>
                    <h4>Are you sure you want to delete this ad from this campaign?</h4>
                    <ul>
                      <li>You will <strong>not</strong> be able to resume this ad once it is removed</li>
                      <li>This ad will be <strong>accessible for 30 days</strong> before it is retired from our network</li>
                    </ul>
                  </div>
                }
                confirmText='Confirm Delete'
                title={`Removing Ad: ${r.title}`}
              >
                <Button
                  bsStyle='danger'
                >
                  Remove Ad
              </Button>
              </Confirm>
            </Popover>
          }
        >
          <div className={`campaign circle ${r.status}`}>

            &nbsp; <FontAwesomeIcon icon='caret-right' />
          </div>
        </OverlayTrigger>
      );
  }

  handleAdTitle(c, ad) {
    return ad.status === 'removed' ? (
      <span>{`${c} (${ad.location})`}</span>
    ) : (
        <a onClick={this.handleAdEdit.bind(this, c, ad)}>
          {`${c} (${ad.location})`}
        </a>);
  }

  handleDisabledRow(row) {
    if (row.status === 'removed') {
      return 'removed-disable';
    }
  }

  showSortedAds() {
    const { sortedAdReport, settings } = this.props;

    return settings.showRemovedAds ? sortedAdReport : sortedAdReport.filter(ad => {
      return ad.status !== 'removed';
    });
  }

  sortStatus(a, b, order) {
    if (order === 'asc') {
      if (statusType[b.status] > statusType[a.status]) {
        return -1;
      } else if (statusType[b.status] < statusType[a.status]) {
        return 1;
      }
      return 0;
    }

    if (statusType[b.status] < statusType[a.status]) {
      return -1;
    } else if (statusType[b.status] > statusType[a.status]) {
      return 1;
    }
    return 0;
  }

  render() {
    const { adsIsLoading, adReportIsLoading, settings } = this.props;
    const data = this.showSortedAds.bind(this)();

    const perPageList = [
      { text: '10', value: 10 },
      { text: '20', value: 20 },
      { text: '50', value: 50 },
      { text: 'ALL', value: data.length }
    ];

    const options = {
      sizePerPageList: perPageList,
      pageStartIndex: 1,
      defaultSortName: 'clicks',
      defaultSortOrder: 'desc'
    };

    const isLoading = adsIsLoading || adReportIsLoading;
    return (
      <Row className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
        <Spinner />
        <Row style={{ marginBottom: '15px' }}>
          <Col md={12}>
            {this.props.children}
            <div className='pull-right'>
              <input
              id="show-removed-ads"
              type="checkbox"
              style={{ marginLeft: '5px', marginRight: '5px' }}
              checked={settings.showRemovedAds}
              onChange={this.handleShowRemovedAds.bind(this)}
              />
              <label
                htmlFor="show-removed-ads"
              >
                Show Removed
              </label>
            </div>
          </Col>
        </Row>
        <BootstrapTable
          striped
          ref='AdReportTable'
          data={data || []}
          pagination
          options={options}
          trClassName={this.handleDisabledRow}
        >
          <TableHeaderColumn
            isKey
            width="35"
            dataField="uuid"
            dataFormat={this.handleStatusPopover.bind(this)}
            dataSort
            sortFunc={this.sortStatus}
          />

          <TableHeaderColumn
            width='250'
            dataField='title'
            dataFormat={this.handleAdTitle.bind(this)}
            dataSort
          >
            Title (Location)
          </TableHeaderColumn>

          <TableHeaderColumn
            width='175'
            dataField='campaign_name'
            dataSort
          >
            Campaign Name
          </TableHeaderColumn>
          <TableHeaderColumn
            width='100'
            dataField='clicks'
            dataFormat={(c) => {
              return (c ? c : 0);
            }}
            dataSort
          >
            Clicks
          </TableHeaderColumn>

          <TableHeaderColumn
            width='110'
            dataField='impressions'
            dataFormat={(c) => {
              return (c ? c : 0);
            }}
            dataSort
          >
            Impressions
          </TableHeaderColumn>

          <TableHeaderColumn
            width='110'
            dataField='conversions'
            dataFormat={(c) => {
              return (c ? c : 0);
            }}
            dataSort
          >
            Applications
          </TableHeaderColumn>

          <TableHeaderColumn
            width='110'
            dataField='spent'
            dataFormat={(c) => {
              return (c ? convertMillsToDollars(c) : '0.00');
            }}
            dataSort
          >
            Spent ($)
          </TableHeaderColumn>

          <TableHeaderColumn
            width='110'
            dataField='cpa'
            dataFormat={(c) => {
              return (c ? c : '0.00');
            }}
            dataSort
          >
            CPA ($)
          </TableHeaderColumn>

          <TableHeaderColumn
            width='110'
            dataField='cpc'
            dataFormat={(c) => {
              return (c ? c : '0.00');
            }}
            dataSort
          >
            CPC ($)
          </TableHeaderColumn>

          <TableHeaderColumn
            width='110'
            dataField='ctr'
            dataFormat={(c) => {
              return (c ? (c * 100).toFixed(2) : '0.00');
            }}
            dataSort
          >
            CTR (%)
          </TableHeaderColumn>
        </BootstrapTable>
        <AdsForm />
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    loader,
    advertiser: {
      ads: { data: ads, loading: adsIsLoading },
      adReports: { data: adReports, loading: adReportIsLoading },
    },
    settings
  } = state;

  const totaledAdReport = {};
  const sortedAdReport = [];
  const account = ownProps.account;
  const startDate = ownProps.startDate;
  const endDate = ownProps.endDate;

  if (adReports.data && ads.data) {
    adReports.data.forEach((currentValue) => {
      totaledAdReport[currentValue.ad_referencenumber] =
        totaledAdReport[currentValue.ad_referencenumber] ||
        {
          count: 0,
          clicks: 0,
          conversions: 0,
          impressions: 0,
          spent: 0,
          cpcSpent: 0,
          cpaSpent: 0
        };

      if (currentValue.bid_type === 'cpc') {
        totaledAdReport[currentValue.ad_referencenumber].cpcSpent += currentValue.spent;
      } else if (currentValue.bid_type === 'cpa') {
        totaledAdReport[currentValue.ad_referencenumber].cpaSpent += currentValue.spent;
      }
      totaledAdReport[currentValue.ad_referencenumber].count++;
      totaledAdReport[currentValue.ad_referencenumber].clicks += currentValue.clicks;
      totaledAdReport[currentValue.ad_referencenumber].conversions += currentValue.conversions;
      totaledAdReport[currentValue.ad_referencenumber].impressions += currentValue.impressions;
      totaledAdReport[currentValue.ad_referencenumber].spent += currentValue.spent;
    });

    ads.data.forEach((ad) => {
      const adReport = totaledAdReport[ad.referencenumber];
      sortedAdReport.push({
        ...adReport,
        ...ad,
        cpa: adReport ? convertMillsToDollars(adReport.cpaSpent / (adReport.conversions || 1)) : 0,
        cpc: adReport ? convertMillsToDollars(adReport.cpcSpent / (adReport.clicks || 1)) : 0,
        ctr: adReport ? ((adReport.clicks / (adReport.impressions || 1))) : 0
      });
    });
  }

  return {
    account,
    adsIsLoading,
    ads,
    adReports,
    adReportIsLoading,
    sortedAdReport,
    adStatusLoading: loader.includes('AdStatusUpdate'),
    settings,
    startDate,
    endDate
  };
};

export default connect(mapStateToProps)(AdsIndexTable);
